import React, { useState } from 'react';
import { Package, Truck, User, Building, Play, ExternalLink, Globe, ArrowRight } from 'lucide-react';

const LockerOneScenarios = () => {
  const [currentLang, setCurrentLang] = useState('sr');

  const translations = {
    sr: {
      title: 'LockerOne',
      subtitle: 'Scenariji korišćenja sistema',
      watchVideo: 'Pogledaj video',
      inDevelopment: 'U RAZVOJU',
      prerequisite: 'Preduslov',
      scenarios: [
        {
          id: 1,
          title: 'Najava pošiljke od strane kurirskog sistema',
          description: 'Kurirski sistem najavljuje pošiljku LockerOne sistemu',
          icon: Package,
          videoUrl: 'https://youtu.be/8_hUA_4Adi8', // Add video URL here
          steps: [
            'Kurirski sistem najavljuje pošiljku LockerOne sistemu',
            'LockerOne pamti pošiljku',
            'LockerOne obavještava korisnika o dolazećoj pošiljci',
            'Korisnik bira ormarić na kojem će preuzeti pošiljku',
            'Korisnik obavlja plaćanje ukoliko je to zahtjevano',
            'LockerOne obavještava kurirski sistem o izabranom ormariću',
            'LockerOne obavještava ormarić o dolazećoj pošiljci'
          ]
        },
        {
          id: 2,
          title: 'Kompanijski depozit',
          description: 'Proces depozita paketa od strane kurira za kompaniju',
          icon: Building,
          prerequisite: 'Pošiljka je najavljena od strane kurirskog sistema',
          videoUrl: 'https://youtu.be/Ac-gozrAYKE', // Add video URL here
          steps: [
            'Kurir bira opciju za depozit',
            'Kurir bira opciju za kompanijski depozit',
            'Kurir bira kompaniju za koju radi',
            'Kurir unosi broj telefona',
            'Kurir dobija kod za prijavu na telefon',
            'Kurir unosi kod za prijavu',
            'Kurir skenira pošiljku',
            'Kurir bira veličinu i vrstu ormarića',
            'Sistem otvara prvi dostupni ormarić',
            'Kurir ubacuje pošiljku u ormarić',
            'Kurir zatvara ormarić',
            'Kurir bira opciju za još jedan depozit',
            'Kurir skenira sledeću pošiljku',
            'Kurir bira veličinu i vrstu ormarića',
            'Sistem otvara sledeći dostupni ormarić',
            'Kurir ubacuje pošiljku u ormarić',
            'Kurir zatvara ormarić',
            'Kurir bira opciju za završavanje depozita'
          ]
        },
        {
          id: 3,
          title: 'Lični depozit',
          description: 'Proces depozita paketa od strane individualnog korisnika',
          icon: User,
          inDevelopment: true,
          videoUrl: '',
          steps: []
        },
        {
          id: 4,
          title: 'Preuzimanje pošiljke',
          description: 'Proces preuzimanja paketa od strane korisnika',
          icon: Truck,
          videoUrl: 'https://youtu.be/DlOZhjgzrpI', // Add video URL here
          steps: [
            'Korisnik bira opciju za preuzimanje paketa',
            'Korisnik unosi broj telefona',
            'Korisnik dobija kod za prijavu na telefon',
            'Korisnik unosi kod za prijavu',
            'Sistem otvara ormarić u kojem se nalazi pošiljka za korisnika',
            'Korisnik uzima pošiljku',
            'Korisnik zatvara ormarić'
          ]
        },
        {
          id: 5,
          title: 'Ostavljanje paketa za dostavu',
          description: 'Proces ostavljanja paketa za dalju dostavu',
          icon: Truck,
          inDevelopment: true,
          videoUrl: '',
          steps: []
        }
      ]
    },
    en: {
      title: 'LockerOne',
      subtitle: 'System usage scenarios',
      watchVideo: 'Watch video',
      inDevelopment: 'IN DEVELOPMENT',
      prerequisite: 'Prerequisite',
      scenarios: [
        {
          id: 1,
          title: 'Package announcement by courier system',
          description: 'Courier system announces package to LockerOne system',
          icon: Package,
          videoUrl: 'https://youtu.be/8_hUA_4Adi8', // Add video URL here
          steps: [
            'Courier system announces package to LockerOne system',
            'LockerOne stores the package information',
            'LockerOne notifies user about incoming package',
            'User selects locker for package pickup',
            'User makes payment if required',
            'LockerOne notifies courier system about selected locker',
            'LockerOne notifies locker about incoming package'
          ]
        },
        {
          id: 2,
          title: 'Company deposit',
          description: 'Package deposit process by courier for company',
          icon: Building,
          prerequisite: 'Package announced by courier system',
          videoUrl: 'https://youtu.be/Ac-gozrAYKE', // Add video URL here
          steps: [
            'Courier selects deposit option',
            'Courier selects company deposit option',
            'Courier selects company they work for',
            'Courier enters phone number',
            'Courier receives login code on phone',
            'Courier enters login code',
            'Courier scans package',
            'Courier selects locker size and type',
            'System opens first available locker',
            'Courier places package in locker',
            'Courier closes locker',
            'Courier selects option for another deposit',
            'Courier scans next package',
            'Courier selects locker size and type',
            'System opens next available locker',
            'Courier places package in locker',
            'Courier closes locker',
            'Courier selects option to finish deposit'
          ]
        },
        {
          id: 3,
          title: 'Personal deposit',
          description: 'Package deposit process by individual user',
          icon: User,
          inDevelopment: true,
          videoUrl: '',
          steps: []
        },
        {
          id: 4,
          title: 'Package pickup',
          description: 'Package pickup process by user',
          icon: Truck,
          videoUrl: 'https://youtu.be/DlOZhjgzrpI', // Add video URL here
          steps: [
            'User selects package pickup option',
            'User enters phone number',
            'User receives login code on phone',
            'User enters login code',
            'System opens locker containing user\'s package',
            'User takes the package',
            'User closes locker'
          ]
        },
        {
          id: 5,
          title: 'Drop-off package for delivery',
          description: 'Process of dropping off package for further delivery',
          icon: Truck,
          inDevelopment: true,
          videoUrl: '',
          steps: []
        }
      ]
    }
  };

  const t = translations[currentLang];

  const ScenarioSection = ({ scenario }) => {
    const IconComponent = scenario.icon;
    
    return (
      <section className="mb-16">
        <div className="border-b border-gray-200 pb-6 mb-8">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 md:gap-0">
            <div className="flex items-center w-full md:w-auto">
              <div className="bg-gray-900 p-3 rounded-lg mr-4">
                <IconComponent className="w-6 h-6 text-white" />
              </div>
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">
                  {scenario.id}. {scenario.title}
                </h2>
                <p className="text-gray-600 text-base md:text-lg">{scenario.description}</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-4 mt-4 md:mt-0">
              {scenario.inDevelopment && (
                <span className="bg-gray-100 text-gray-700 text-xs md:text-sm px-3 py-1 rounded-full font-medium">
                  {t.inDevelopment}
                </span>
              )}
              
              {!scenario.inDevelopment && (
                <a
                  href={scenario.videoUrl || '#'}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-3 md:px-4 py-2 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors text-xs md:text-base"
                >
                  <Play className="w-4 h-4 mr-2" />
                  {t.watchVideo}
                  <ExternalLink className="w-4 h-4 ml-2" />
                </a>
              )}
            </div>
          </div>
          
          {scenario.prerequisite && (
            <div className="mt-4 bg-gray-50 border-l-4 border-gray-400 p-4">
              <p className="text-xs md:text-sm text-gray-700">
                <span className="font-medium">{t.prerequisite}:</span> {scenario.prerequisite}
              </p>
            </div>
          )}
        </div>

        {scenario.steps.length > 0 && (
          <div className="space-y-4">
            {scenario.steps.map((step, index) => (
              <div key={index} className="flex items-center">
                <div className="flex-shrink-0 w-8 h-8 bg-gray-900 text-white rounded-full flex items-center justify-center text-sm font-medium mr-4">
                  {index + 1}
                </div>
                <div className="flex-1">
                  <p className="text-gray-800 leading-relaxed text-sm md:text-base break-words">{step}</p>
                </div>
                <ArrowRight className="flex-shrink-0 w-4 h-4 text-gray-400 ml-4 hidden sm:block" />
              </div>
            ))}
          </div>
        )}

        {scenario.inDevelopment && (
          <div className="text-center py-8 md:py-12">
            <div className="inline-flex items-center px-4 md:px-6 py-2 md:py-3 bg-gray-100 rounded-lg">
              <span className="text-gray-600 font-medium text-sm md:text-base">{t.inDevelopment}</span>
            </div>
          </div>
        )}
      </section>
    );
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-gray-900 text-white">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-8 md:py-12">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 md:gap-0">
            <div>
              <h1 className="text-2xl md:text-4xl font-bold mb-2 md:mb-3">{t.title}</h1>
              <p className="text-lg md:text-xl text-gray-300">{t.subtitle}</p>
            </div>
            {/* Language toggle */}
            <div className="flex items-center space-x-2 md:space-x-3 mt-4 md:mt-0">
              <Globe className="w-5 h-5 text-gray-400" />
              <button
                onClick={() => setCurrentLang(currentLang === 'sr' ? 'en' : 'sr')}
                className="px-3 md:px-4 py-2 bg-white bg-opacity-10 text-white rounded-lg hover:bg-opacity-20 transition-colors font-medium text-xs md:text-base"
              >
                {currentLang === 'sr' ? 'Srpski' : 'English'}
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="max-w-6xl mx-auto px-4 md:px-6 py-8 md:py-12">
        {t.scenarios.map((scenario) => (
          <ScenarioSection key={scenario.id} scenario={scenario} />
        ))}
      </main>

      {/* Footer */}
      <footer className="bg-gray-50 border-t">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-6 md:py-8">
          <div className="text-center text-gray-600">
            <p className="font-medium text-gray-900 mb-1 md:mb-2 text-base md:text-lg">{t.title}</p>
            <p className="text-xs md:text-sm">{t.subtitle}</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LockerOneScenarios;